module.exports = __webpack_public_path__ + "img/symbol_7.1fda7a19.png";